import ToggleSwitch from '../../../../../../../components/toggle-switch/ToggleSwitch';
import { Box, Divider, Typography } from '@mui/material';
import i18n from 'i18';

export const SwitchField = ({ data, field, onChange, ...props }) => {
    const { id, label, options, fullWidth, needDivider } = field;
    const formattedOptions = options.map((option) => ({
        value: option,
        label: i18n.t(`enums.${option}`)
    }));
    return (
        <div>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: fullWidth ? 'flex-start' : 'center',
                    justifyContent: fullWidth ? 'flex-start' : 'space-between',
                    flexDirection: fullWidth ? 'column' : 'row',
                    mb: 2,
                    gap: 2
                }}
            >
                <Typography variant="h5">
                    {i18n.t(`columns.${label}`)}
                </Typography>
                <ToggleSwitch
                    options={formattedOptions}
                    fullWidth={fullWidth}
                    value={data}
                    onChange={(value) => onChange(id, value)}
                />
            </Box>
            {needDivider && <Divider sx={{ mb: 2 }} />}
        </div>
    );
};
